import { ensureExists } from '@wix/answers-lib';
import { getBaseReactDriver } from './base-driver';
export var findInPopover = function (selector) {
    var maybeElem = document.body.querySelector(".Popover " + selector);
    var child = ensureExists(maybeElem, "Element with selector " + selector + " was not found in a Popover");
    return getBaseReactDriver(child);
};
//# sourceMappingURL=find-in-popover.js.map